import { render, staticRenderFns } from "./solutions.vue?vue&type=template&id=7965f330&scoped=true"
import script from "./solutions.vue?vue&type=script&lang=js"
export * from "./solutions.vue?vue&type=script&lang=js"
import style0 from "./solutions.vue?vue&type=style&index=0&id=7965f330&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7965f330",
  null
  
)

export default component.exports